//#region IMPORTS
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  Paper,
  Chip,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Grid,
  Divider,
} from "@mui/material";
import {
  Print as PrintIcon,
  PictureAsPdf as PdfIcon,
  Close as CloseIcon,
  Receipt as ReceiptIcon,
} from "@mui/icons-material";
import { UrlApi } from "../../../../../../../../services/apirest";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
//#endregion

export default function ReciboDetalleView({
  open,
  onClose,
  data,
  mode, //Preview - View
  clienteData,

  onConfirm,
  formatNumeroRecibo,
  formatDate,
  formatCurrency,
}) {
  if (!data) return null;

  const {
    recibo,
    retenciones,
    tarjetas,
    instrumentos_bancarios,
    imputaciones,
    totales,
  } = data;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ bgcolor: "primary.main", color: "white", py: 2 }}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Box display="flex" alignItems="center" gap={2}>
            <ReceiptIcon sx={{ fontSize: 32 }} />
            <Box>
              <Typography variant="h5" fontWeight="bold">
                RECIBO
              </Typography>
              <Typography variant="subtitle2">
                {mode === "Preview"
                  ? "--VISTA PREVIA--"
                  : `Número: ${formatNumeroRecibo(data)}`}
              </Typography>
            </Box>
          </Box>
          <Chip
            label={formatDate(recibo.fecha_de_pago)}
            sx={{
              bgcolor: "white",
              color: "primary.main",
              fontWeight: "bold",
            }}
          />
        </Box>
      </DialogTitle>

      <DialogContent sx={{ p: 0 }}>
        {/* INFORMACIÓN DEL CLIENTE Y RECIBO */}
        <Paper sx={{ p: 3, bgcolor: "grey.50" }} elevation={0}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Typography
                variant="caption"
                color="text.secondary"
                fontWeight="bold"
              >
                CLIENTE
              </Typography>
              <Typography variant="body1" fontWeight="600">
                {clienteData?.razon_social || "N/A"}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                CUIT: {recibo.cuit}
              </Typography>
            </Grid>

            <Grid item xs={6} md={3}>
              <Typography
                variant="caption"
                color="text.secondary"
                fontWeight="bold"
              >
                fecha de pago
              </Typography>
              <Typography variant="body1" fontWeight="600">
                {formatDate(recibo.fecha_de_pago)}
              </Typography>
              <Typography
                variant="caption"
                color="text.secondary"
                fontWeight="bold"
              >
                fecha de contabilidad
              </Typography>
              <Typography variant="body1" fontWeight="600">
                {formatDate(recibo.created_at ?? new Date())}
              </Typography>
            </Grid>

            <Grid item xs={6} md={3}>
              <Typography
                variant="caption"
                color="text.secondary"
                fontWeight="bold"
              >
                TIPO
              </Typography>
              <Typography variant="body1" fontWeight="600">
                {recibo.es_recibo_electronico ? "Electrónico" : "Manual"}
              </Typography>
            </Grid>
          </Grid>
        </Paper>

        <Divider />

        {/* MEDIOS DE PAGO */}
        <Box sx={{ p: 3 }}>
          <Typography
            variant="h6"
            fontWeight="bold"
            gutterBottom
            sx={{ mb: 2, color: "primary.main" }}
          >
            MEDIOS DE PAGO
          </Typography>

          <TableContainer component={Paper} variant="outlined">
            <Table size="small">
              <TableBody>
                {/* EFECTIVO */}
                {totales?.efectivo > 0 && (
                  <TableRow>
                    <TableCell sx={{ fontWeight: 600, width: "70%" }}>
                      Efectivo
                    </TableCell>
                    <TableCell align="right" sx={{ fontWeight: 600 }}>
                      {formatCurrency(totales.efectivo)}
                    </TableCell>
                  </TableRow>
                )}

                {/* INSTRUMENTOS BANCARIOS */}
                {instrumentos_bancarios?.map((inst, index) => (
                  <TableRow key={inst.id}>
                    <TableCell>
                      <Typography variant="body2" fontWeight="600">
                        {inst.forma_de_pago} - {inst.banco_nombre}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        Nro: {inst.nro_comprobante} | Fecha de emisión:{" "}
                        {formatDate(inst.fecha)}
                        {inst.fecha_de_pago &&
                          ` | Fecha de pago: ${formatDate(inst.fecha_de_pago)}`}
                        {inst.cuit_firma && ` | CUIT: ${inst.cuit_firma}`}
                      </Typography>
                    </TableCell>
                    <TableCell align="right" sx={{ fontWeight: 600 }}>
                      {formatCurrency(inst.importe)}
                    </TableCell>
                  </TableRow>
                ))}

                {/* TARJETAS */}
                {tarjetas?.map((tarj, index) => (
                  <TableRow key={tarj.id}>
                    <TableCell>
                      <Typography variant="body2" fontWeight="600">
                        {tarj.valor}
                        {tarj.marca ? ` ${tarj.marca}` : ""} -{" "}
                        {tarj.banco_nombre}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">
                        **** **** **** {tarj.ultimos4} | Lote: {tarj.lote} |
                        Cupón: {tarj.cupon}
                      </Typography>
                    </TableCell>
                    <TableCell align="right" sx={{ fontWeight: 600 }}>
                      {formatCurrency(tarj.importe)}
                    </TableCell>
                  </TableRow>
                ))}
                {/* INFO REDONDEO */}
                {totales?.redondeo > 0 && (
                  <TableRow>
                    <TableCell
                      colSpan={2}
                      sx={{ borderBottom: "none", py: 1.5 }}
                    >
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1.2,
                          bgcolor: "warning.50",
                          border: "1px solid",
                          borderColor: "warning.200",
                          borderRadius: 2,
                          px: 2,
                          py: 1.2,
                        }}
                      >
                        <WarningAmberIcon
                          sx={{
                            color: "warning.main",
                            fontSize: 22,
                          }}
                        />

                        <Typography
                          variant="body2"
                          sx={{
                            color: "warning.dark",
                            fontWeight: 600,
                            lineHeight: 1.4,
                          }}
                        >
                          Se realizará un ajuste de crédito en cuenta corriente
                          por {formatCurrency(totales.redondeo)} correspondiente
                          al redondeo.
                        </Typography>
                      </Box>
                    </TableCell>
                  </TableRow>
                )}
                {/* SUBTOTAL MEDIOS DE PAGO */}
                <TableRow sx={{ bgcolor: "grey.100" }}>
                  <TableCell sx={{ fontWeight: 700 }}>TOTAL</TableCell>
                  <TableCell align="right" sx={{ fontWeight: 700 }}>
                    {formatCurrency(
                      totales?.efectivo +
                        totales?.total_instrumentos +
                        totales?.total_tarjeta,
                    )}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Box>

        <Divider />

        {/* RETENCIONES */}
        {retenciones && totales.total_retenciones > 0 && (
          <Box sx={{ p: 3 }}>
            <Typography
              variant="h6"
              fontWeight="bold"
              gutterBottom
              sx={{ mb: 2, color: "warning.main" }}
            >
              RETENCIONES
            </Typography>

            <TableContainer component={Paper} variant="outlined">
              <Table size="small">
                <TableBody>
                  {/* RETENCIÓN SUSS */}
                  {retenciones.suss > 0 && (
                    <TableRow>
                      <TableCell sx={{ fontWeight: 600 }}>
                        Retención SUSS
                      </TableCell>
                      <TableCell align="right" sx={{ fontWeight: 600 }}>
                        {formatCurrency(retenciones.suss)}
                      </TableCell>
                    </TableRow>
                  )}

                  {/* RETENCIÓN IVA */}
                  {retenciones.iva > 0 && (
                    <TableRow>
                      <TableCell sx={{ fontWeight: 600 }}>
                        Retención IVA
                      </TableCell>
                      <TableCell align="right" sx={{ fontWeight: 600 }}>
                        {formatCurrency(retenciones.iva)}
                      </TableCell>
                    </TableRow>
                  )}

                  {/* RETENCIÓN GANANCIAS */}
                  {retenciones.ganancias > 0 && (
                    <TableRow>
                      <TableCell sx={{ fontWeight: 600 }}>
                        Retención Ganancias
                      </TableCell>
                      <TableCell align="right" sx={{ fontWeight: 600 }}>
                        {formatCurrency(retenciones.ganancias)}
                      </TableCell>
                    </TableRow>
                  )}

                  {/* RETENCIÓN DREI */}
                  {retenciones.drei > 0 && (
                    <TableRow>
                      <TableCell sx={{ fontWeight: 600 }}>
                        Retención DREI
                      </TableCell>
                      <TableCell align="right" sx={{ fontWeight: 600 }}>
                        {formatCurrency(retenciones.drei)}
                      </TableCell>
                    </TableRow>
                  )}

                  {/* DESGLOSE DE IIBB POR PROVINCIA (Pedido de Joana) */}
                  {retenciones.iibb?.length > 0 && (
                    <>
                      {retenciones.iibb.map((iibb) => (
                        <TableRow key={iibb.id}>
                          <TableCell sx={{ fontWeight: 600, pl: 4 }}>
                            <Typography variant="body2">
                              Ret. IIBB - {iibb.provincia}
                            </Typography>
                            <Typography
                              variant="caption"
                              color="text.secondary"
                            >
                              Provincia ID: {iibb.provincia_id}
                            </Typography>
                          </TableCell>
                          <TableCell align="right" sx={{ fontWeight: 600 }}>
                            {formatCurrency(iibb.importe)}
                          </TableCell>
                        </TableRow>
                      ))}
                    </>
                  )}

                  {/* TOTAL RETENCIONES */}
                  <TableRow sx={{ bgcolor: "warning.50" }}>
                    <TableCell sx={{ fontWeight: 700 }}>
                      TOTAL RETENCIONES
                    </TableCell>
                    <TableCell
                      align="right"
                      sx={{ fontWeight: 700, color: "warning.main" }}
                    >
                      {formatCurrency(totales.total_retenciones)}
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        )}

        <Divider />

        {/* IMPUTACIONES */}
        {imputaciones && imputaciones.length > 0 && (
          <>
            <Divider />
            <Box sx={{ p: 3 }}>
              <Typography
                variant="h6"
                fontWeight="bold"
                gutterBottom
                sx={{ mb: 2, color: "info.main" }}
              >
                APLICACIONES
              </Typography>

              <TableContainer component={Paper} variant="outlined">
                <Table size="small">
                  <TableBody>
                    {imputaciones?.map((imp) => (
                      <TableRow key={imp.id}>
                        <TableCell>
                          <Typography variant="body2" fontWeight="600">
                            {imp.comprobante} - {imp.nro_factura}
                          </Typography>
                          <Typography variant="caption" color="text.secondary">
                            Fecha aplicacion: {formatDate(imp.fecha_imputacion)}
                          </Typography>
                        </TableCell>
                        <TableCell align="right" sx={{ fontWeight: 600 }}>
                          {formatCurrency(imp.importe)}
                        </TableCell>
                      </TableRow>
                    ))}

                    {/* TOTAL IMPUTADO */}
                    <TableRow sx={{ bgcolor: "info.50" }}>
                      <TableCell sx={{ fontWeight: 700 }}>
                        TOTAL APLICADO
                      </TableCell>
                      <TableCell
                        align="right"
                        sx={{ fontWeight: 700, color: "info.main" }}
                      >
                        {formatCurrency(
                          imputaciones?.reduce(
                            (acc, curr) => acc + Number(curr.importe),
                            0,
                          ),
                        )}
                      </TableCell>
                    </TableRow>
                    {/* LO QUE FALTA POR IMPUTAR */}

                    <TableRow sx={{ bgcolor: "info.50" }}>
                      <TableCell sx={{ fontWeight: 700 }}>
                        RESTANTE A APLICAR
                      </TableCell>
                      <TableCell
                        align="right"
                        sx={{ fontWeight: 700, color: "success.main" }}
                      >
                        {formatCurrency(
                          totales.total -
                            imputaciones?.reduce(
                              (acc, curr) => acc + Number(curr.importe),
                              0,
                            ),
                        )}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Box>
          </>
        )}
        <Divider />
        {/* TOTALES FINALES */}
        <Box sx={{ p: 3, bgcolor: "grey.50" }}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Box
                sx={{
                  p: 2,
                  bgcolor: "white",
                  borderRadius: 1,
                  textAlign: "center",
                }}
              >
                <Typography variant="caption" color="text.secondary">
                  Aplicaciones
                </Typography>
                <Typography variant="h6" fontWeight="bold">
                  {formatCurrency(
                    totales.efectivo +
                      totales.total_instrumentos +
                      totales.total_tarjeta,
                  )}
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={6}>
              <Box
                sx={{
                  p: 2,
                  bgcolor: "white",
                  borderRadius: 1,
                  textAlign: "center",
                }}
              >
                <Typography variant="caption" color="text.secondary">
                  Retenciones
                </Typography>
                <Typography variant="h6" fontWeight="bold">
                  {formatCurrency(totales.total_retenciones)}
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12}>
              <Box
                sx={{
                  p: 3,
                  bgcolor: "success.main",
                  color: "white",
                  borderRadius: 1,
                  textAlign: "center",
                }}
              >
                <Typography variant="body2" sx={{ mb: 1 }}>
                  TOTAL
                </Typography>
                <Typography variant="h4" fontWeight="bold">
                  {formatCurrency(totales.total)}
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </DialogContent>

      <DialogActions sx={{ px: 3, py: 2, bgcolor: "grey.50" }}>
        {mode === "View" && (
          <>
            {/* <Button
              variant="outlined"
              startIcon={<PrintIcon />}
              onClick={() => window.print()}
            >
              Imprimir
            </Button> */}

            <Button
              variant="outlined"
              startIcon={<PdfIcon />}
              onClick={async () => {
                try {
                  const response = await fetch(
                    `${UrlApi}/ctacte/recibos/download/pdf/${data.recibo.id}`,
                  );
                  const blob = await response.blob();
                  const url = URL.createObjectURL(blob);

                  const a = document.createElement("a");
                  a.href = url;
                  a.download = `recibo-${data.recibo.id}.pdf`;
                  a.click();

                  URL.revokeObjectURL(url);
                } catch (error) {
                  console.error("Error al descargar:", error);
                }
              }}
            >
              Descargar PDF
            </Button>
          </>
        )}
        <Box sx={{ flex: 1 }} />
        <Button variant="contained" onClick={onClose} startIcon={<CloseIcon />}>
          Cerrar
        </Button>
        {mode === "Preview" && (
          <Button variant="contained" color="success" onClick={onConfirm}>
            Confirmar Recibo
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
}
